import InternationalCollaboratorMap from "Explore/Components/InternationalCollaboratorMap";
import SectionTitle from "Explore/Components/SectionTitle";
import { TIME_FILTER_OPTIONS } from "Explore/Config/constraint";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useState } from "react";
import { getFacultyInternationalCollaborators } from "Explore/Services/Author";
import PublicIcon from "@mui/icons-material/Public";

const CollaboratorMap = () => {
  const { entity_id: id } = useExploreInfo();
  const [data, setData] = useState({ data: [], isLoading: true });
  const [countries, setCountries] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [timeFilter, setTimeFilter] = useState(TIME_FILTER_OPTIONS[1].value);

  useEffect(() => {
    if (!id) return;
    setData({ data: [], isLoading: true });
    getFacultyInternationalCollaborators({
      id,
      keyword: selectedKeywords,
      timeFilter,
    })
      .then((res) => {
        setData({ data: res?.results || [], isLoading: false });
      })
      .catch(() => {
        setData({ data: [], isLoading: false });
      });
  }, [id, selectedKeywords, timeFilter]);

  return (
    <div style={{ position: "relative", marginBottom: "40px" }}>
      <SectionTitle
        title='Collaborators All Over the World'
        icon={<PublicIcon />}
      />
      <InternationalCollaboratorMap
        data={data.data}
        isLoading={data.isLoading}
        countries={countries}
        setCountries={setCountries}
        selectedKeywords={selectedKeywords}
        setSelectedKeywords={setSelectedKeywords}
        timeFilter={timeFilter}
        setTimeFilter={setTimeFilter}
      />
    </div>
  );
};

export default CollaboratorMap;
